import React, {useEffect, useState} from 'react';
import {
  Chip,
  Autocomplete,
  TextField, Button
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import LargePopper from "../../../../components/Table/assets/LargePopper";
import api from "../../../../services/api";
import Box from "@mui/material/Box";
import AddIcon from "@mui/icons-material/Add";
import ColorizeIcon from "@mui/icons-material/Colorize";
import {SlidingPaneAddNew} from "../../../../components/Page/SlidingPaneAddNew";
import {serviceProviderDriver} from "../../../../schema/serviceProviderDriver";
import toast from "react-hot-toast";

export default function SelectStaffField({
                                             params,
                                            type,
                                           props,
                                            onChangeValue,
                                           }: {
  params: any;
  props?: any;
  type?: any;
  onChangeValue?: (value:any) => void;
}) {
  const [selectOptions, setSelectOptions] = useState<[]>([]);
  const [loading, setLoading] = useState(false);
  const transformedValue = params.value;

  const fetchSelectOptions = async () => {
    setLoading(true);

    const searchParams = new URLSearchParams({});

      searchParams.set(
        'service_provider_id',(type === 'card'?'185': '83')
      );

      searchParams.set('service_id', type === 'card' ? params.row?.service?.id : params.row?.service_reservation?.service?.id);

      await api
        .get(`/admin/get-staff-by-service`, searchParams)
        .then((res: any) => {
          setSelectOptions(res);
          setLoading(false);
        });
  };

  const onChange = (event: any, value: any) => {

    if (type === 'card'){
      api
        .post(`/service-provider/service-reservation-confirmations/set-staff/${params?.row?.id}`, {
          selected_staff: value,
        })
        .then((res: any) => {
          toast.success('Sikeres mentés');
        }).catch(()=>{
        toast.error('Sikertelen mentés');
      });
    }else{
      props.api.setEditCellValue({
        id: props.id,
        field: props.field,
        value: value,
      });
    }

  };

  return (
    <>
      <Autocomplete
        PopperComponent={LargePopper}
        freeSolo
        loading={loading}
        onOpen={() => fetchSelectOptions()}
        fullWidth={true}
        size="small"
        options={selectOptions}
        getOptionLabel={(option) => option?.name}
        getOptionKey={(option) => option?.id}
        value={transformedValue}
        onChange={(event, newValue) => {
          onChange(event, newValue);
        }}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              size="small"
            />
          );
        }}
      />
    </>
  );
}
